/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const PencilSimpleOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m12.53 6.22 5.25 5.25m-9.31 9H4.28a.75.75 0 0 1-.75-.75v-4.19c0-.1.02-.2.06-.29.03-.09.09-.17.16-.24L15 3.75c.07-.07.15-.13.24-.16a.717.717 0 0 1 .58 0c.09.03.17.09.24.16l4.19 4.18a.821.821 0 0 1 .22.54.753.753 0 0 1-.22.53L9 20.25c-.07.07-.16.12-.25.16s-.18.06-.28.06z"
})); // Fill


const PencilSimpleFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m20.785 7.41-4.15-4.17a1.562 1.562 0 0 0-1.66-.36c-.18.08-.36.19-.5.34l-2.47 2.46-8.78 8.79c-.14.14-.25.3-.33.48-.07.18-.11.38-.11.58v4.19a1.499 1.499 0 0 0 1.5 1.5h4.19c.4-.01.78-.16 1.06-.44l11.25-11.25a1.524 1.524 0 0 0 0-2.12zm-3 3-4.19-4.19 1.94-1.94 4.19 4.19-1.94 1.94z"
})); // DuoTone


const PencilSimpleDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m12.53 6.22 5.25 5.25L20.25 9a.776.776 0 0 0 .22-.53.821.821 0 0 0-.22-.54l-4.19-4.18a.633.633 0 0 0-.24-.16.717.717 0 0 0-.58 0c-.09.03-.17.09-.24.16l-2.47 2.47z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m12.53 6.22 5.25 5.25m-9.31 9H4.28a.75.75 0 0 1-.75-.75v-4.19c0-.1.02-.2.06-.29.03-.09.09-.17.16-.24L15 3.75c.07-.07.15-.13.24-.16a.717.717 0 0 1 .58 0c.09.03.17.09.24.16l4.19 4.18a.821.821 0 0 1 .22.54.753.753 0 0 1-.22.53L9 20.25c-.07.07-.16.12-.25.16s-.18.06-.28.06z"
}));
/**
  Icon PencilSimpleIcon in design group
*/


export const PencilSimpleIcon = createIcon('PencilSimpleIcon', 'pencil-simple', 'design', PencilSimpleOutline, PencilSimpleFill, PencilSimpleDuotone, "0 0 24 24");